import MojitoPresentation from 'mojito/presentation';
import EventCardSkeleton from './card/index.js';
import { memo, useCallback, useState } from 'react';
import { noop } from 'mojito/utils';
import { useLoadingStatusMetric } from 'modules/performance/hooks';

const { LoaderSuspense } = MojitoPresentation.Components;

export default function withEventCardSkeleton(
    EventCard,
    useLoadDone = () => false,
    loaderConfigResolver = noop
) {
    const EventCardWrapper = props => {
        const {
            mojitoTools: { config, instanceId },
            reportLoadingStatus,
        } = props;

        const cardContentLoaded = useLoadDone(props);
        const [cardLoaded = cardContentLoaded, setCardLoaded] = useState(undefined);
        const onLoadDone = useCallback(() => setCardLoaded(true), []);
        const loaderConfig = loaderConfigResolver(config) || config.eventCard.skeletonLoader;

        const performanceElementRef = useLoadingStatusMetric(
            cardLoaded,
            reportLoadingStatus ? instanceId : undefined,
            'EventCard'
        );

        return (
            <EventCardContent
                {...props}
                renderer={EventCard}
                loaderConfig={loaderConfig}
                cardLoaded={cardLoaded}
                onLoadDone={onLoadDone}
                performanceElementRef={performanceElementRef}
            />
        );
    };

    return EventCardWrapper;
}

// eslint-disable-next-line react/display-name
const EventCardContent = memo(props => {
    const {
        loaderConfig,
        cardLoaded,
        shouldRequestData = true,
        performanceElementRef,
        onLoadDone,
        renderer: Element,
    } = props;
    return (
        <LoaderSuspense
            config={loaderConfig}
            isContentPending={!cardLoaded && shouldRequestData}
            loader={<EventCardSkeleton elementRef={performanceElementRef} />}
        >
            <Element {...props} onLoadDone={onLoadDone} elementRef={performanceElementRef} />
        </LoaderSuspense>
    );
});
